import { Button, Divider, Flex, Form, Input, Modal, Typography } from 'antd'
import { submitBanClient } from 'src/pages/worldCup2026/participants/model'
import { Client } from 'src/pages/worldCup2026/types'

type Props = {
  client: Client | null
  onClose: () => void
}

type FormValues = {
  banReason: string
}

export const BanModal = ({ client, onClose }: Props) => {
  const { Item } = Form
  const { Text } = Typography
  const { TextArea } = Input

  const handleSubmit = ({ banReason }: FormValues) => {
    if (!client?.clientId) return
    submitBanClient({ id: client?.clientId, banReason })
    onClose()
  }

  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>
          Set disqualification reason for {client?.fullName}
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={Boolean(client)}
      onCancel={onClose}
      footer={null}
    >
      <Divider />
      <Form layout="vertical" onFinish={handleSubmit}>
        <Item
          required={false}
          name="banReason"
          label={
            <Text style={{ fontSize: 16 }} strong>
              Enter a reason
            </Text>
          }
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: 'Required field',
            },
          ]}
        >
          <TextArea rows={6} autoFocus placeholder="Reason" />
        </Item>
        <Divider />
        <Flex gap={8} justify="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          <Button danger type="primary" htmlType="submit">
            Ok
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
